// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"86b94144","703":"2ea7a323"}[chunkId] + ".chunk.js";
};